import { render, staticRenderFns } from "./InvolvedParties.vue?vue&type=template&id=00cb034a&scoped=true"
import script from "./InvolvedParties.vue?vue&type=script&lang=ts"
export * from "./InvolvedParties.vue?vue&type=script&lang=ts"
import style0 from "./InvolvedParties.vue?vue&type=style&index=0&id=00cb034a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb034a",
  null
  
)

export default component.exports